import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // Responsive CSS

import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5"; // Responsive JS
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-buttons/js/buttons.colVis.min.js";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import "../Vendor/VendorLeads/VendorLeadDataTableCSS.css";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { useAuth } from "../../../Store/AuthContext";

DataTable.use(DT);

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function WalletTransactionDataTable() {
  const { userID, RendomTokenfetch } = useAuth();
  const navigate = useNavigate();
  const [WalletTransactionData, setWalletTransactionData] = useState([]);
  console.log(WalletTransactionData);

  // *********** DataTable Coulmns *********
  const columns = [
    {
      title: `<input type="checkbox" id="selectAll" name="allrowCheckStaus"/>`, // Header checkbox
      data: null,
      orderable: false,
      searchable: false,
      render: (data, type, row) => {
        return `<input type="checkbox" id="rowcheck${row.id}" name="rowcheckStatuschange" class="row-checkbox" data-id="${row.id}" />`;
      },
    },

    {
      title: "Transaction ID",
      data: "transactionid",
    },
    {
      title: "Order ID",
      data: "order_id",
    },

    {
      title: "Amount",
      data: "amount",
      render: (data, type, row) => {
        return `<span class="text-primary fw-500">
                                 ₹ ${data}
                                </span>`;
      },
    },
    {
      title: "Payment Status",
      data: "payment_status",
      render: (data, type, row) => {
        let requSts = "";
        if (data === "1") {
          requSts = `<span class="badge bg-success">
                                  Success
                                </span>`;
        } else {
          requSts = `<span class="badge bg-danger">
                                  Faild
                                </span>`;
        }

        return `${requSts}`;
      },
    },
    { title: "Payment Date", data: "payment_date" },
    { title: "Bank Ref. Number", data: "bank_ref_num" },

    {
      title: "Action",
      data: "order_id",
      createdCell: (td, cellData, rowData) => {
        // Start with empty HTML
        td.innerHTML = "";

        // View Button
        const viewBtn = document.createElement("button");
        viewBtn.className = "newspaperviewbtn me-1";
        viewBtn.title = "View";
        viewBtn.innerHTML = `<i class="fa fa-eye" aria-hidden="true"></i>`;
        viewBtn.onclick = () => {
          navigate(`/wallet-transaction-details/${rowData.order_id}`);
        };
        td.appendChild(viewBtn);
      },
    },
  ];

  useEffect(() => {
    const handleSelectAll = function () {
      const isChecked = $(this).is(":checked");
      $(".row-checkbox").prop("checked", isChecked);
    };
    const handleRowCheckbox = function () {
      const allChecked =
        $(".row-checkbox").length === $(".row-checkbox:checked").length;
      $("#selectAll").prop("checked", allChecked);
    };

    // Handle row click navigation

    $(document).on("change", "#selectAll", handleSelectAll);
    $(document).on("change", ".row-checkbox", handleRowCheckbox);

    return () => {
      $(document).off("change", "#selectAll", handleSelectAll);
      $(document).off("change", ".row-checkbox", handleRowCheckbox);
    };
  }, [navigate, userID, RendomTokenfetch]);

  return (
    <>
      {/* ************Data Table Rows ************* */}
      <div className="row">
        <div className="col-lg-12">
          <div className="ls-widget mb-0">
            <div className="tabs-box">
              <div
                className="widgetcontent p-3 table-responsive"
                style={{ overflowX: "auto" }}
              >
                <DataTable
                  className="table table-striped table-bordered vendordatatable"
                  columns={columns}
                  responsive={true}
                  noHeader={true}
                  style={{ tableLayout: "auto", width: "100%" }}
                  processing={true}
                  options={{
                    responsive: false,
                    ordering: false,
                    scrollX: true,
                    dom: "Bfrtip",

                    buttons: [
                      {
                        extend: "copy",
                        text: `<i class="fa fa-clone"></i>`,
                        className: "btn btn-sm",
                        titleAttr: "Copy to clipboard",
                        exportOptions: {
                          columns: ":visible",
                        },
                      },
                      {
                        extend: "excelHtml5",
                        text: `<i class="fa fa-file-excel-o"></i>`,
                        className: "btn btn-sm",
                        titleAttr: "Export to Excel",
                        exportOptions: {
                          columns: ":visible",
                        },
                      },
                      {
                        extend: "pdfHtml5",
                        text: `<i class="fa fa-file-pdf-o"></i>`,
                        className: "btn btn-sm",
                        titleAttr: "Export to PDF",
                        exportOptions: {
                          columns: ":visible",
                        },
                      },
                      {
                        extend: "print",
                        text: '<i class="fa fa-print"></i>',
                        className: "btn btn-sm",
                        titleAttr: "Print table",
                        exportOptions: {
                          columns: ":visible",
                          modifier: {
                            page: "all",
                          },
                        },
                      },
                      {
                        extend: "colvis",
                        text: "Column Visibility", // Boxicon for Column Visibility
                        className: "btn btn-sm",
                        titleAttr: "Toggle column visibility",
                      },
                      {
                        extend: "pageLength",
                        text: "Show Rows",
                        className: "btn btn-sm",
                        titleAttr: "Change Number of Rows Displayed",
                      },
                    ],
                    lengthMenu: [
                      [10, 50, 100, 150, 200, -1],
                      [10, 50, 100, 150, 200, "All"],
                    ],

                    colVis: {
                      restore: true,
                    },

                    stateSave: true,
                    deferRender: true,
                    scrollCollapse: true,
                    scroller: true,
                    pagingType: "full_numbers",
                    fixedHeader: true,
                    autoWidth: false,
                    serverSide: true,
                    paging: true,
                    pageLength: 10,
                    ajax: (data, callback) => {
                      const page = Math.floor(data.start / data.length) + 1;
                      const limit = data.length;

                      axios
                        .get(`${WebsiteAPIurl}allwallettransction`, {
                          params: {
                            userid: userID,
                            page: page,
                            limit: limit,
                            search: data.search.value,
                          },
                          headers: { Authorization: RendomTokenfetch },
                        })
                        .then((res) => {
                          const r = res.data;
                          // console.log(res.data);
                          const total = parseInt(r.totalcount) || 0;
                          const data = Array.isArray(r.allwallettransectiondata)
                            ? r.allwallettransectiondata
                            : [];

                          setWalletTransactionData(data);

                          callback({
                            data: r.allwallettransectiondata,
                            recordsTotal: total,
                            recordsFiltered: total,
                          });
                        })
                        .catch(() =>
                          callback({
                            data: [],
                            recordsTotal: 0,
                            recordsFiltered: 0,
                          })
                        );
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
